
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { getAdminProfile } from "api/ApiServices";

import routes from "routes.js";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/globle.css";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [isSidebarPinned, setIsSidebarPinned] = React.useState(false);
  const [userRole, setUserRole] = React.useState(localStorage.getItem("userRole") || "admin");

  const toggleSidebar = () => {
    setIsSidebarPinned(!isSidebarPinned);
  };

  React.useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getAdminProfile();

        let fetchedRole = "admin";

        if (data?.payload?.role) {
          fetchedRole =
            (data.payload.role.name || data.payload.role)
              .toLowerCase()
              .trim();
        }

        setUserRole(fetchedRole);
        localStorage.setItem("userRole", fetchedRole);

        //  SAVE PERMISSIONS
        if (data?.payload?.permissions) {
          const keys = data.payload.permissions.map((p) => p.p_name || p.p_key);

          localStorage.setItem("userPermissions", JSON.stringify(keys));
        }

        window.dispatchEvent(new Event("userRoleUpdated"));
      } catch (err) { }
    };

    fetchProfile();
  }, []);

  React.useEffect(() => {
    if (isSidebarPinned) {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.add("sidebar-pinned");
    } else {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.remove("sidebar-pinned");
    }
  }, [isSidebarPinned]);

  // Global Modal & Backdrop Styles
  React.useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .modal { z-index: 1060; }
      .modal-backdrop { z-index: 1055; }
      
      @media (min-width: 1200px) {
        body.sidebar-pinned .modal {
          left: 250px !important;
          width: calc(100% - 250px) !important;
        }
        body.sidebar-pinned .modal-backdrop {
          left: 250px !important;
          width: calc(100% - 250px) !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout !== "/admin") return null;

      const role = userRole?.toLowerCase();

      //  If route is judge-only
      if (prop.role === "judge" && role !== "judge") {
        return null;
      }

      //  If user is not super admin / admin → allow ONLY specific routes based on permissions
      const isSuperAdmin = role === "super admin" || role === "admin";
      if (!isSuperAdmin) {
        const allowedPaths = ["/profile"];
        if (role === "judge") {
          allowedPaths.push("/judges-dashboard");
        }

        let userPermissions = [];
        try {
          userPermissions = JSON.parse(localStorage.getItem("userPermissions") || "[]");
        } catch (e) { }

        const isRouteAllowed = (routeProp) => {
          if (routeProp.path === "/rooms-chats/:id") {
            return true;
          }
          if (!routeProp.name) {
            // E.g. /rooms-chats/:id, check parent route /rooms-chats
            const parentPath = routeProp.path.split('/:')[0];
            const parentRoute = routes.find(r => r.path === parentPath);
            if (parentRoute && parentRoute.name) {
              return allowedPaths.includes(parentRoute.path) || userPermissions.includes(parentRoute.name);
            }
            return true;
          }
          return allowedPaths.includes(routeProp.path) || userPermissions.includes(routeProp.name);
        };

        if (!isRouteAllowed(prop)) {
          return null;
        }
      }

      return (
        <Route
          path={prop.path}
          element={prop.component}
          key={key}
        />
      );
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        path.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Dashboard";
  };

  const getFallbackRedirect = () => {
    const role = userRole?.toLowerCase();
    if (role === "judges" || role === "judge") {
      return "/admin/judges-dashboard";
    }
    const isSuperAdmin = role === "super admin" || role === "admin";
    if (isSuperAdmin) {
      return "/admin/index";
    }

    let userPermissions = [];
    try {
      userPermissions = JSON.parse(localStorage.getItem("userPermissions") || "[]");
    } catch (e) { }

    const firstAllowedRoute = routes.find(route => {
      if (route.layout !== "/admin" || !route.name) return false;
      if (route.role === "judge") return false;
      return userPermissions.includes(route.name);
    });

    return firstAllowedRoute ? `/admin${firstAllowedRoute.path}` : "/admin/profile";
  };

  return (
    <>
      {/* Sidebar Component - Navigation Menu */}
      <Sidebar
        {...props}
        location={location}
        routes={routes}
        isPinned={isSidebarPinned}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/icons/common/image__5_-removebg-preview 1.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(location.pathname)}
          isSidebarPinned={isSidebarPinned}
          toggleSidebar={toggleSidebar}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to={getFallbackRedirect()} replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
